import cl from 'classnames';
import React from 'react';

import './ColumnDividerBoxItem.scss';

export interface ColumnDividerBoxItemProps extends React.HTMLAttributes<HTMLDivElement> {
    /** No padding on the item */
    noPadding?: boolean;
    /** No dividing line below the item */
    noDivider?: boolean;
    /** No dividing line below the item */
    align?: 'left' | 'center' | 'right';
    /** Column divider box item */
    children?: React.ReactNode;
}

const ColumnDividerBoxItem = ({
    noPadding = false,
    noDivider = false,
    align,
    children,
    className,
    ...rest
}: ColumnDividerBoxItemProps): React.JSX.Element | null => {
    if (children) {
        return (
            <div
                className={cl(
                    'kortbetjening-column-divider-box__item',
                    align && `kortbetjening-column-divider-box__item--align--align-${align}`,
                    className,
                    {
                        'kortbetjening-column-divider-box__item--no-padding': noPadding,
                        'kortbetjening-column-divider-box__item--no-divider': noDivider,
                        'kortbetjening-column-divider-box__item--align': align,
                    },
                )}
                {...rest}
            >
                {children}
            </div>
        );
    }

    return null;
};

export default ColumnDividerBoxItem;
